export const DIALOG_TRANSITION_DURATION = 0.25;
export const DIALOG_WIDTH = 420;
export const REPLY_TRANSITION_DELAY = 0.5;
export const ORGANIZATION_CONTACT_LINK =
  'https://www.together.ai/contact-sales';

export const CSB_FRIENDS_LINK =
  'https://codesandbox.io/docs/learn/plans/codesandbox-friends';
